import AOS from 'aos';

import './utils/vh.utils.js';
import './utils/eq-height.utils.js';
import './utils/animate-on-view.utils';
import './utils/meta.utils.js';

import './components/meta/select.component.js';
import './components/meta/btn-upload.component.js';
import './components/project-dropdown.component.js';

import './components/marquee/_index.js';
import './components/swiper/_index.js';
import './components/cards/_index.js';
import './components/sections/_index.js';
import './components/animations/_index.js';
import './components/accordion.component.js';

import './components/validation.component.js';

import './components/uploadFile.component.js';
import './components/contact-attachment.component.js';
import './components/header.component.js';
import './components/inputs.component.js';
import './components/animations.component.js';
import './components/player.component.js';
import './components/search-sec.component.js';

import './libs/countUp.lib.js';
import './libs/smoothScrollbar.lib.js';


AOS.init({
  offset: 50,
  delay: 10,
  duration: 600,
  easing: 'ease-in-out',
  once: true,
  startEvent: 'DOMContentLoaded',
});


const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if(isSafari) document.body.classList.add('is-safari');


const clearItems = document.querySelectorAll('[data-clear-child-inline] *');

if(clearItems.length) {
  clearItems?.forEach((item) => {
    item.style = null;
  })
}


(function () {
  const PROCESSED = 'data-slash-fixed';

  function processTitle(el) {
    if (el.hasAttribute(PROCESSED)) return;
    el.setAttribute(PROCESSED, '');

    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    let n;
    while ((n = walker.nextNode())) textNodes.push(n);

    textNodes.forEach((textNode) => {
      if (!/\S\/\S/.test(textNode.textContent)) return;

      const parent = textNode.parentNode;
      if (!parent) return;

      const text = textNode.textContent;
      const fragment = document.createDocumentFragment();
      const re = /\S\/\S/g;
      let last = 0;
      let match;

      while ((match = re.exec(text)) !== null) {
        // slice up to and including the slash (match.index = char before /, +2 = char after /)
        fragment.appendChild(document.createTextNode(text.slice(last, match.index + 2)));
        fragment.appendChild(document.createElement('wbr'));
        last = match.index + 2;
        re.lastIndex = last; // allow overlap: "a/b/c" → two breaks
      }

      fragment.appendChild(document.createTextNode(text.slice(last)));
      parent.replaceChild(fragment, textNode);
    });
  }

  function fixAll(root) {
    try {
      root.querySelectorAll(`.job-card__title:not([${PROCESSED}])`).forEach(processTitle);
    } catch (_) {}
  }

  fixAll(document);

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        try {
          if (node.matches('.job-card__title')) {
            processTitle(node);
          } else {
            fixAll(node);
          }
        } catch (_) {}
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}());


